import css from './definitionPane.module.scss';
import cssPane from '../wordPane.module.scss';

import cx from 'classnames';
import { memo, useState } from 'react';

import { ImageResource } from 'com/ImageResource';
import { getEntries } from 'core/helpers/object';
import { useAutoFontSize } from 'core/helpers/useAutoFontSize';

import Definition from './Definition';
import Note from './Note';

type TProps = {
  word: TWord;
  finished: boolean;
};

const DefinitionDefaultPane: React.FC<TProps> = ({ word, finished }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  useAutoFontSize(container);

  return (
    <div
      className={cx(
        cssPane.wordSplitPane,
        css.container,
        word.valueResourceUid && css.hyphenize
      )}
    >
      <div className={css.body} ref={setContainer}>
        {getEntries<TLangAndNone, string | undefined>(word.definitions).map(
          ([lang, text]) =>
            text && <Definition key={lang} text={text} lang={lang} />
        )}
        {word.note && <Note key="note" note={word.note} finished={finished} />}
      </div>
      {word.definitionResourceUid && (
        <div className={css.image}>
          <ImageResource resourceUid={word.definitionResourceUid} />
        </div>
      )}
    </div>
  );
};

export default memo(DefinitionDefaultPane);
